module.exports = __webpack_public_path__ + "img/game-of-life-quick.bcf0b9e5.png";